import { useEffect, useState } from 'react';

/** Used to determine if we're on the client or not. */
export default function useClientSide() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsClient(true);
    }
  }, []);

  return isClient;
}
